

































import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {enhancedEcommerce} from '../../shared/helpers/enhanced-ecommerce';

@Component({
  name: 'catalog-product-list',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;

  private get isLoading(): boolean {
    return this.$store.getters[`${this.dataSource}/isLoading`];
  }

  private get products(): Array<object> {
    return this.$store.getters[`${this.dataSource}/productList`];
  }

  private updated(): void {
    this.$nextTick(() => {
      ('.catalog__category-list a h2').matchHeight(false);
      ('.product__tile .product__holder').matchHeight(false);
      ('.product__tile .product__holder--bottom').matchHeight(false);
      const resizeEvent = new UIEvent('resize');
      window.dispatchEvent(resizeEvent);
    });
  }

  private created(): void {
    enhancedEcommerce.addProductImpressions(this.products);
    window.dispatchEvent(new Event('rrinit'));
  }
  private get wishlistItems() {
    return this.$store.getters['CustomerWishlist/wishlistProducts'];
  }
  private checkIsOnWishlist(productId: string): boolean {
    return this.wishlistItems.some((item: object) => item['product_id'] === productId);
  }
}
